import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { BbField } from '@/app/pages/create-brief-select/ui/bb-field/bb-field';
import { CreateScreeningService } from '@/app/pages/screening-brief-create/services/create-screening/create-screening.service';
import { ScreeningReportType } from '@/app/common/general-types/social-screening.dto';
import { REPORT_PROMPT_EXAMPLES, STANDARD_REPORT_INCLUDES } from '../../screening-brief.constants';

/**
 * Wizard step 4 — take the standard screening report, or write the spec for a custom analysis.
 *
 * The standard scoring runs either way; a custom prompt only changes how results are presented.
 */
@Component({
  selector: 'sbs-screening-report-type',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BbField],
  templateUrl: './screening-report-type.html',
})
export class ScreeningReportTypeSection {

  readonly createScreeningService = inject(CreateScreeningService);

  readonly standardIncludes = STANDARD_REPORT_INCLUDES;
  readonly promptExamples = REPORT_PROMPT_EXAMPLES;

  readonly promptCount = computed(() => this.createScreeningService.reportPrompt().trim().length);

  select(type: ScreeningReportType): void {
    this.createScreeningService.reportType.set(type);
  }

  setPrompt(value: string): void {
    this.createScreeningService.reportPrompt.set(value);
  }

  /** Example chips append a line rather than replacing what the user has already written. */
  appendExample(example: string): void {
    this.createScreeningService.reportPrompt.update((current) => {
      const trimmed = current.replace(/\s*$/, '');
      return trimmed ? `${trimmed}\n${example}` : example;
    });
  }
}
